export default "__VITE_PUBLIC_ASSET__534fec0b__"